<dt-modal-content size="small" [showX]="false">
  <ng-template #title i18n>E-Mail-Adresse bestätigen</ng-template>
  <ng-template #content>
    <div i18n>Gib bitte den Verifizierungscode ein, den Du per E-Mail erhalten hast.</div>

    <form [formGroup]="confirmForm" (ngSubmit)="onSubmit()" class="dt-form">
      <mat-form-field>
        <mat-label i18n>Verifizierungscode</mat-label>
        <input matInput formControlName="token" required />
        @if (confirmForm.hasError('required', 'token')) {
          <mat-error i18n>Bitte gib den Verifizierungscode ein</mat-error>
        }
        @if (confirmForm.hasError('pattern', 'token')) {
          <mat-error i18n>Der Verifizierungscode muss aus 6 Ziffern bestehen</mat-error>
        }
        @if (confirmForm.hasError('invalidToken', 'token')) {
          <mat-error i18n>Der Verifizierungscode ist ungültig</mat-error>
        }
      </mat-form-field>

      @if (confirmForm.hasError('serverError')) {
        <mat-error i18n>Beim Übermitteln der Daten ist ein Fehler aufgetreten.</mat-error>
      }

      <button
        mat-raised-button
        [dtOverlayProgress]="confirmForm.disabled"
        type="submit"
        color="accent"
        [disabled]="confirmForm.disabled"
        i18n
        >Bestätigen</button
      >
    </form>

    <div class="center">
      <div class="mat-small" i18n>Keinen Code erhalten? Prüfe Deinen Spam-Ordner.</div>
      <div>
        <a (click)="requestNewCode()" i18n>Code erneut zusenden</a>
        &nbsp;·&nbsp;
        <a (click)="skip()" i18n>Überspringen</a>
        &nbsp;·&nbsp;
        <a (click)="logout()" i18n>Abmelden</a>
      </div>
    </div>
  </ng-template>
</dt-modal-content>
